import { RecordLabelState } from './state';
import { recordLabelsInitialState, resetOnboarding } from './initial-state';
import { RecordLabelsActions } from './action-creators';
import * as actions from './actions';

export const recordLabelReducer = (
  state: RecordLabelState = recordLabelsInitialState,
  action: RecordLabelsActions
): RecordLabelState => {
  switch (action.type) {
    case actions.SET_ACTIVE_LABEL: {
      return {
        ...state,
        active: action.label,
      };
    }

    case actions.GET_RECORD_LABELS_SUCCESS: {
      return {
        ...state,
        loaded: true,
        list: action.list,
      };
    }

    case actions.GET_ARTIST_RECORD_LABELS_SUCCESS: {
      return {
        ...state,
        member: action.list,
      };
    }

    case actions.UPDATE_RECORD_LABEL_NAME: {
      return {
        ...state,
        list: state.list.map((r) => {
          if (r.id === action.recordLabelId) {
            return {
              ...r,
              name: action.name,
            };
          }

          return r;
        }),
      };
    }

    case actions.UPDATE_RECORD_LABEL_RELATION_SPLIT: {
      return {
        ...state,
        artists: {
          ...state.artists,
          [action.relation.recordLabelId]: state.artists[
            action.relation.recordLabelId
          ].map((rel) => {
            if (rel.artistId === action.relation.artistId) {
              return {
                ...rel,
                ...action.relation,
                split: action.split,
              };
            }

            return rel;
          }),
        },
      };
    }

    case actions.UPDATE_RECORD_LABEL:
    case actions.UPDATE_RECORD_LABEL_SUCCESS: {
      return {
        ...state,
        active:
          state.active?.id === action.recordLabel.id
            ? {
                ...action.recordLabel,
              }
            : state.active,
        list: state.list.map((r) => {
          if (r.id === action.recordLabel.id) {
            return {
              ...r,
              ...action.recordLabel,
            };
          }

          return r;
        }),
      };
    }

    case actions.UPDATE_RECORD_LABEL_ARTIST_COUNT: {
      return {
        ...state,
        list: state.list.map((r) => {
          if (r.id === action.recordLabelId) {
            return {
              ...r,
              artistCount: r.artistCount ? r.artistCount + 1 : 1,
            };
          }

          return r;
        }),
      };
    }

    case actions.DELETE_RECORD_LABEL_SUCCESS: {
      return {
        ...state,
        list: state.list.filter((i) => i.id !== action.recordLabelId),
      };
    }

    case actions.ATTACH_TO_RECORD_LABEL_SUCCESS: {
      const artistList = state.artists[action.relation.recordLabelId] || [];

      return {
        ...state,
        artists: {
          ...state.artists,
          [action.relation.recordLabelId]: artistList.concat([action.relation]),
        },
      };
    }

    case actions.REMOVE_FROM_RECORD_LABEL: {
      const artistList = state.artists[action.relation.recordLabelId] || [];

      return {
        ...state,
        artists: {
          ...state.artists,
          [action.relation.recordLabelId]: artistList.filter(
            (r) => r.artistId !== action.relation.artistId
          ),
        },
      };
    }

    case actions.LIST_RECORD_LABEL_ARTIST_SUCCESS: {
      return {
        ...state,
        artists: {
          ...state.artists,
          [action.recordLabelId]: action.list,
        },
      };
    }

    case actions.CREATE_RECORD_LABEL_SUCCESS: {
      return {
        ...state,
        list: state.list.concat([action.recordLabel]),
      };
    }

    case actions.LIST_RECORD_LABEL_OPERATORS_SUCCESS: {
      return {
        ...state,
        operators: {
          ...state.operators,
          [action.recordLabelId]: action.list,
        },
      };
    }

    case actions.CREATE_RECORD_LABEL_OPERATOR_SUCCESS: {
      return {
        ...state,
        operators: {
          ...state.operators,
          [action.recordLabelId]: state.operators[action.recordLabelId].concat(
            action.operator
          ),
        },
      };
    }

    case actions.REMOVE_OPERATOR_FROM_RECORD_LABEL: {
      const operatorsList = state.operators[action.recordLabelId] || [];

      return {
        ...state,
        operators: {
          ...state.operators,
          [action.recordLabelId]: operatorsList.filter(
            (r) => r.userId !== action.operatorId
          ),
        },
      };
    }

    case actions.LABEL_ONBOARDING_START: {
      return {
        ...state,
        onboarding: {
          ...resetOnboarding(),
          started: true,
        },
      };
    }

    case actions.LABEL_ONBOARDING_UPGRADE: {
      return {
        ...state,
        active: action.recordLabel,
        onboarding: {
          ...resetOnboarding(),
          started: false,
          name: action.recordLabel.name || '',
        },
      };
    }

    case actions.LABEL_ONBOARDING_SELECT_PLAN: {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          plan: {
            product: action.product,
            price: action.price,
            quantity: 1,
          },
        },
      };
    }

    case actions.LABEL_ONBOARDING_UPDATE_NAME: {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          name: action.name,
        },
      };
    }

    case actions.LABEL_ONBOARDING_ADD_ARTIST: {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          artists: state.onboarding.artists.concat([action.artist]),
        },
      };
    }

    case actions.LABEL_ONBOARDING_REMOVE_ARTIST: {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          artists: state.onboarding.artists.filter(
            (a) => a.contact.value !== action.contact
          ),
        },
      };
    }

    default:
      return state;
  }
};
